import { dataStarSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconStarSolid = /*#__PURE__*/createIcon(dataStarSolid)
export default IconStarSolid
